export default "/images/b083f099a6df47df1ccacbf672773c09.avif";